/**
 * Firebase Auth sometimes omits user.email on the User object while the Google
 * address is still present on providerData — use both for admin checks.
 */
export function resolveAuthEmail(user) {
  if (!user) return null;
  const direct = user.email?.trim();
  if (direct) return direct.toLowerCase();
  for (const provider of user.providerData || []) {
    const fromProvider = provider?.email?.trim();
    if (fromProvider) return fromProvider.toLowerCase();
  }
  return null;
}
